import React, { useContext, useMemo } from "react";
import { FabekeDropdown } from "./FabekeDropdown";
import { useTextDomainContext } from "@/app/providers";
import { string, func, bool, oneOf } from "prop-types";
import { AutocompleteDropdown } from "./AutocompleteDropdown";
import { SimpleDropdown } from "./SimpleDropdown";
import { useDataLimitList } from "@/hooks";

/**
 * Customer dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export const DataLimitDropdownCommon = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { dataLimitList } = useDataLimitList({});

  const options = useMemo(() => {
    const firstOption = {
      label: gettext("No Historical Data Limit"),
      value: "",
    };
    if (dataLimitList && dataLimitList.length > 0) {
      const formattedOptions = dataLimitList.map((item: any) => ({
        label: item.label,
        value: item.value,
      }));
      return [firstOption, ...formattedOptions];
    }
    return [firstOption];
  }, [dataLimitList, gettext]);

  //#region useMemo
  const dropdownProps = useMemo(() => {
    // const activeOptions =
    //   options?.filter((item) => item.status === "Active") || [];

    const ddProps: any = {
      options,
      componentLabel: gettext("Historical Data"),
      defaultValue: "",
      visualStyle: "autoComplete",
      size: "small",
    };

    if (props.componentLabel) {
      ddProps.componentLabel = props.componentLabel;
    }

    if (props.defaultValue) {
      ddProps.defaultValue = props.defaultValue;
    }

    if (props.required) {
      ddProps.required = props.required;
    }

    return ddProps;
  }, [
    gettext,
    options,
    props.componentLabel,
    props.defaultValue,
    props.required,
  ]);
  //#endregion useMemo

  //#region Handlers
  /**
   * Handles change event of the partner dropdown
   * @param {object} event event object
   * @returns {void}
   */
  const handleChange = (event: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
  };
  //#endregion Handlers

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown
          onChange={handleChange}
          {...(dropdownProps as any)}
        />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown onChange={handleChange} {...(dropdownProps as any)} />
      )}

      {props.visualStyle === "old" && (
        <FabekeDropdown onChange={handleChange} {...(dropdownProps as any)} />
      )}
    </>
  );
};

DataLimitDropdownCommon.propTypes = {
  componentLabel: string,
  defaultValue: string,
  onChange: func,
  required: bool,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
};
